// Copy for the Beeline-only landing pages (/beeline1, /beeline2, /beeline3) in English, Russian and Kyrgyz.

export const LANGS = [
  { code: 'en', label: 'English', short: 'EN' },
  { code: 'ru', label: 'Русский', short: 'RU' },
  { code: 'ky', label: 'Кыргызча', short: 'KY' },
];

export const DEFAULT_LANG = 'ru';

export const PRICES = { daily: 12 };

export const TARIFFS = [
  { id: 'gb70', gb: 70, price: 500, bonuses: 3 },
  { id: 'gb100', gb: 100, price: 700, bonuses: 4 },
  { id: 'unl', gb: null, price: 850, bonuses: 5 },
  { id: 'gb250', gb: 250, price: 1500, bonuses: 3 },
  { id: 'family', gb: null, price: 790, bonuses: 1, family: true },
];

export const CONTACTS = { phone: '+996 (775) 580 611', help: '*611', email: 'answer@beeline.kg' };

export const content = {
  en: {
    meta: { title: 'Kid Security with Beeline', description: 'Track, communicate and control in one app — together with Beeline.' },
    nav: { parent: 'What does a parent get?', kids: 'Why do kids like it?', how: 'How to connect?', tariffs: 'Which plans include it?', faq: 'FAQ' },
    hero: {
      badge: 'For Beeline subscribers',
      title: 'Kid Security – a service for your children’s safety!',
      text: 'Track, communicate and control in one app together with Beeline.',
      cta: 'Try with Beeline',
      perks: ['GPS tracker', 'Live listening', 'Screen-time limits'],
    },
    strip: ['Beeline', 'Kid Security', 'Peace of mind for your family!'],
    form: {
      title: 'Choose your subscription',
      daily: 'Per day', currency: 'som',
      phoneTitle: 'Enter your number',
      phoneLabel: 'Mobile number',
      placeholder: 'xxx xxx xxx',
      hint: 'You must be a Beeline subscriber',
      button: 'Subscribe',
      loading: 'Please wait…',
      close: 'Close',
      terms: 'By tapping “Subscribe” you connect the Kid Security service. It is billed to your Beeline balance and renews automatically. You can manage or cancel it in the My Beeline app or by calling *611.',
      from: '12 som/day',
      errInvalid: 'Please enter a valid Beeline number',
      errNotBeeline: 'This offer is only available to Beeline subscribers (numbers starting 22, 50, 60, 77).',
      errAlready: 'This number is already subscribed.',
      errGeneric: 'We could not connect the service. Please try again in a moment.',
    },
    parent: {
      title: 'What does a parent get from Kid Security?',
      sub: 'The #1 parental control app',
      cta: 'Try it now',
      items: [
        { icon: '/Location.png', img: '/GpsBoy.png', title: 'GPS tracker', text: 'Always know where your child is and get alerts when they leave a safe zone.' },
        { icon: '/Ear.png', img: '/AudioGirl.png', title: 'Live listening', text: 'Hear the sounds around your child in real time, even if they don’t pick up the phone.' },
        { icon: '/Limit.png', img: '/GamingBoy.png', title: 'Game limits', text: 'Limit the time spent in apps and block websites.' },
      ],
    },
    apps: {
      parentName: 'Kid Security', parentRole: 'App for the parent',
      kidName: 'Tigrow', kidRole: 'App for the child',
      result: 'Complete protection for your child!',
    },
    kids: {
      title: 'Why do kids love “Tigrow”?',
      sub: 'The app for children that works together with Kid Security',
      items: [
        { icon: '/Rocket.png', img: '/BoyOnRocket.png', title: 'Dreams come true', text: 'Your child adds a dream to the app and you set its price in virtual coins. Save up enough and the dream comes true!' },
        { icon: '/Heart.png', img: '/GirlOnPhoneCard.png', title: 'Motivation to grow', text: 'Every day your child completes useful tasks for school, home and sport and earns virtual coins!' },
        { icon: '/Controller.png', img: '/BoyOnEarth.png', title: 'Coins for fun', text: 'Earned coins can be exchanged for a dream or for extra time for games and entertainment on the phone!' },
      ],
    },
    flow: [{ title: 'Subscribe', text: 'Enter your number above and tap Subscribe' },{ title: 'Download the app', text: 'Install Kid Security on your phone' },{ title: 'Link with a PIN', text: 'Link your child’s phone with a PIN code' }],
    formula: ['1 connection', '2 downloads', '1 service'],
    steps: {
      title: '3 simple steps',
      step: 'Step',
      s1: {
        title: 'Connect a plan',
        text: 'Some Beeline plans include a free Kid Security subscription.',
        cta: 'Choose a plan', or: 'Or', title2: 'Connect the service',
        text2: 'If your plan has no free subscription, connect it separately from 12 som/day.', cta2: 'Connect the service',
      },
      s2: {
        title: 'Download Kid Security for the parent',
        text: 'Kid Security is the parent app that helps you follow your child via GPS, manage screen time and stay in touch with the family.',
        text2: 'Generate a PIN code in this app and send it to your child’s number to link them to you.',
      },
      s3: {
        title: 'Download Tigrow for the child',
        text: 'Tigrow works together with Kid Security. It shares your child’s location and lets them earn virtual coins for useful tasks.',
        text2: 'Enter the PIN code in Tigrow to link it to the parent.',
      },
    },
    tariffs: {
      title: 'Plans with a Kid Security subscription',
      perMonth: '/ 30 days', gb: 'GB', unlimited: 'Unlimited internet', family: 'Family', thisIs: 'This is',
      wifi: '10 GB for Wi-Fi sharing',
      bonuses: (n) => (n === 1 ? '1 free bonus of your choice' : `${n} free bonuses of your choice`),
      inBonus: 'Kid Security in the bonus pack',
      sim: 'Get a SIM card',
      more: 'More details',
    },
    faq: {
      title: 'Frequently asked questions',
      items: [
        { q: 'What is Kid Security?', a: 'Kid Security is a parental control app: GPS location with safe-zone alerts, live listening, app time limits and website blocking, all in one place.' },
        { q: 'How much does it cost?', a: 'The service costs 12 som per day, charged to your Beeline balance. Some Beeline plans include it for free.' },
        { q: 'Who can connect?', a: 'Any Beeline Kyrgyzstan subscriber. The service is billed through your Beeline number, so a number from another operator cannot subscribe.' },
        { q: 'Do I need a second app?', a: 'Yes. Install Kid Security on the parent’s phone and Tigrow on the child’s phone, then link them with a PIN code.' },
        { q: 'How do I cancel?', a: 'Manage or cancel the subscription in the My Beeline app or call the helpline *611.' },
      ],
    },
    manage: { title: 'Manage the service easily in the “My Beeline” app' },
    sticky: 'Subscribe',
    footer: { offices: 'Sales offices', help: 'Helpline', rights: 'All rights reserved' },
    result: {
      successTitle: 'Done! The service is connected',
      successText: 'Download Kid Security on your phone and Tigrow on your child’s phone, then link them with a PIN code.',
      failedTitle: 'Something went wrong',
      failedText: 'The service could not be connected. Please try again later.',
      back: 'Back to the page',
    },
  },

  ru: {
    meta: { title: 'Kid Security с Beeline', description: 'Отслеживайте, общайтесь и контролируйте в одном приложении вместе с Beeline.' },
    nav: { parent: 'Что получает родитель?', kids: 'Почему нравится детям?', how: 'Как подключить услугу?', tariffs: 'В каких тарифах есть услуга?', faq: 'Вопросы' },
    hero: {
      badge: 'Для абонентов Beeline',
      title: 'Kid Security – сервис для безопасности ваших детей!',
      text: 'Отслеживайте, общайтесь и контролируйте в одном приложении вместе с Beeline.',
      cta: 'Попробовать с Beeline',
      perks: ['GPS-трекер', 'Прослушивание', 'Лимит на игры'],
    },
    strip: ['Beeline', 'Kid Security', 'Спокойствие для вашей семьи!'],
    form: {
      title: 'Выберите тип подписки',
      daily: 'В день', currency: 'сом',
      phoneTitle: 'Введите ваш номер',
      phoneLabel: 'Номер телефона',
      placeholder: 'xxx xxx xxx',
      hint: 'Важно быть абонентом Beeline',
      button: 'Подписаться',
      loading: 'Подождите…',
      close: 'Закрыть',
      terms: 'Нажимая «Подписаться», вы подключаете услугу Kid Security. Оплата списывается с баланса Beeline, подписка продлевается автоматически. Управлять услугой или отключить её можно в приложении «Мой Beeline» или по номеру *611.',
      from: '12 сом/день',
      errInvalid: 'Введите корректный номер Beeline',
      errNotBeeline: 'Предложение доступно только абонентам Beeline (номера на 22, 50, 60, 77).',
      errAlready: 'Этот номер уже подписан на услугу.',
      errGeneric: 'Не удалось подключить услугу. Попробуйте ещё раз чуть позже.',
    },
    parent: {
      title: 'Что получает родитель от Kid Security?',
      sub: 'Приложение №1 по родительскому контролю',
      cta: 'Попробовать сейчас',
      items: [
        { icon: '/Location.png', img: '/GpsBoy.png', title: 'GPS-трекер', text: 'Всегда знайте, где находится ваш ребенок, и получайте уведомления, если он покидает безопасные зоны.' },
        { icon: '/Ear.png', img: '/AudioGirl.png', title: 'Прослушивание', text: 'Слушайте звуки вокруг ребенка в режиме реального времени, даже если он не берет трубку.' },
        { icon: '/Limit.png', img: '/GamingBoy.png', title: 'Лимит на игры', text: 'Ограничивайте время использования приложений и блокируйте сайты.' },
      ],
    },
    apps: {
      parentName: 'Kid Security', parentRole: 'Приложение для родителя',
      kidName: 'Tigrow', kidRole: 'Приложение для ребенка',
      result: 'Комплексная защита ребенка!',
    },
    kids: {
      title: 'Почему детям нравится «Tigrow»?',
      sub: 'Приложение для детей, работает в паре с Kid Security',
      items: [
        { icon: '/Rocket.png', img: '/BoyOnRocket.png', title: 'Мечты в реальность', text: 'Ребенок вносит мечту в приложение, вы определяете её стоимость в виртуальных монетах. Накопив нужную сумму, мечта сбывается!' },
        { icon: '/Heart.png', img: '/GirlOnPhoneCard.png', title: 'Мотивация на рост', text: 'Каждый день ребенок выполняет полезные задания по учебе, дому и спорту, и зарабатывает виртуальные монеты!' },
        { icon: '/Controller.png', img: '/BoyOnEarth.png', title: 'Обмен монет на развлечения', text: 'Заработанные монеты ребенок может обменять как на мечту, так и на дополнительное время на игры и развлечения в телефоне!' },
      ],
    },
    flow: [{ title: 'Подключите услугу', text: 'Введите номер и нажмите «Подписаться»' },{ title: 'Скачайте приложение', text: 'Установите Kid Security на свой телефон' },{ title: 'Введите ПИН-код', text: 'Свяжите телефон ребенка с помощью ПИН-кода' }],
    formula: ['1 подключение', '2 скачивания', '1 сервис'],
    steps: {
      title: '3 простых шага',
      step: 'Шаг',
      s1: {
        title: 'Подключите тариф',
        text: 'У Beeline есть тарифы, где имеется бесплатная подписка на услугу Kid Security.',
        cta: 'Выбрать тариф', or: 'Или', title2: 'Подключите услугу',
        text2: 'Если в вашем тарифе нет бесплатной подписки, подключите её отдельно от 12 сом/день.', cta2: 'Подключить услугу',
      },
      s2: {
        title: 'Скачайте родителю приложение Kid Security',
        text: 'Kid Security — это приложение для родителей, которое помогает следить за ребенком через GPS, контролировать время за экраном и поддерживать связь с семьей.',
        text2: 'Сгенерируйте ПИН-код в этом приложении и отправьте его на номер ребенка, чтобы привязать к себе.',
      },
      s3: {
        title: 'Скачайте ребенку приложение Tigrow',
        text: 'Tigrow — работает в паре с Kid Security. Приложение следит за местоположением вашего ребенка и позволяет ему зарабатывать виртуальные монеты за полезные задания.',
        text2: 'Введите ПИН-код в приложение Tigrow, чтобы подвязаться к родителю.',
      },
    },
    tariffs: {
      title: 'Тарифы с подпиской на Kid Security',
      perMonth: '/ 30 дней', gb: 'ГБ', unlimited: 'Безлимитный интернет', family: 'Семья', thisIs: 'Это',
      wifi: '10 ГБ на раздачу Wi-Fi',
      bonuses: (n) => (n === 1 ? '1 бесплатный бонус на выбор' : n < 5 ? `${n} бесплатных бонуса на выбор` : `${n} бесплатных бонусов на выбор`),
      inBonus: 'Kid Security в бонускане',
      sim: 'Получить SIM-карту',
      more: 'Подробнее',
    },
    faq: {
      title: 'Частые вопросы',
      items: [
        { q: 'Что такое Kid Security?', a: 'Kid Security — приложение родительского контроля: GPS-геолокация с уведомлениями о безопасных зонах, прослушивание, лимиты на приложения и блокировка сайтов в одном месте.' },
        { q: 'Сколько это стоит?', a: 'Услуга стоит 12 сом в день и списывается с баланса Beeline. В некоторые тарифы Beeline она входит бесплатно.' },
        { q: 'Кто может подключить?', a: 'Любой абонент Beeline Кыргызстан. Услуга оплачивается через номер Beeline, поэтому номер другого оператора подписаться не сможет.' },
        { q: 'Нужно ли второе приложение?', a: 'Да. Установите Kid Security на телефон родителя и Tigrow на телефон ребенка, затем свяжите их ПИН-кодом.' },
        { q: 'Как отключить услугу?', a: 'Управляйте подпиской или отключите её в приложении «Мой Beeline» либо по справочному номеру *611.' },
      ],
    },
    manage: { title: 'Управляйте услугой удобно в приложении «Мой Beeline»' },
    sticky: 'Подписаться',
    footer: { offices: 'Офисы продаж', help: 'Справочная', rights: 'Все права защищены' },
    result: {
      successTitle: 'Готово! Услуга подключена',
      successText: 'Скачайте Kid Security на свой телефон и Tigrow на телефон ребенка, затем свяжите их ПИН-кодом.',
      failedTitle: 'Что-то пошло не так',
      failedText: 'Не удалось подключить услугу. Попробуйте позже.',
      back: 'Вернуться на страницу',
    },
  },

  ky: {
    meta: { title: 'Beeline менен Kid Security', description: 'Бир колдонмодо Beeline менен бирге байкаңыз, баарлашыңыз жана көзөмөлдөңүз.' },
    nav: { parent: 'Ата-эне эмне алат?', kids: 'Балдарга эмне жагат?', how: 'Кантип туташтыруу керек?', tariffs: 'Кайсы тарифтерде бар?', faq: 'Суроолор' },
    hero: {
      badge: 'Beeline абоненттери үчүн',
      title: 'Kid Security – балдарыңыздын коопсуздугу үчүн сервис!',
      text: 'Бир колдонмодо Beeline менен бирге байкаңыз, баарлашыңыз жана көзөмөлдөңүз.',
      cta: 'Beeline менен байкап көрүү',
      perks: ['GPS-трекер', 'Угуу', 'Оюндарга чектөө'],
    },
    strip: ['Beeline', 'Kid Security', 'Үй-бүлөңүздүн тынчтыгы үчүн!'],
    form: {
      title: 'Жазылуу түрүн тандаңыз',
      daily: 'Күнүнө', currency: 'сом',
      phoneTitle: 'Номериңизди киргизиңиз',
      phoneLabel: 'Телефон номери',
      placeholder: 'xxx xxx xxx',
      hint: 'Beeline абоненти болушуңуз керек',
      button: 'Жазылуу',
      loading: 'Күтө туруңуз…',
      close: 'Жабуу',
      terms: '«Жазылуу» баскычын басуу менен Kid Security кызматын туташтырасыз. Төлөм Beeline балансынан алынат, жазылуу автоматтык түрдө узартылат. Кызматты «Мой Beeline» колдонмосунда же *611 номери аркылуу башкарып же өчүрсөңүз болот.',
      from: 'күнүнө 12 сом',
      errInvalid: 'Beeline номерин туура киргизиңиз',
      errNotBeeline: 'Сунуш Beeline абоненттери үчүн гана (22, 50, 60, 77 менен башталган номерлер).',
      errAlready: 'Бул номер кызматка мурунтан эле жазылган.',
      errGeneric: 'Кызмат туташкан жок. Бираз убакыттан кийин кайра аракет кылыңыз.',
    },
    parent: {
      title: 'Ата-эне Kid Security’ден эмне алат?',
      sub: '№1 ата-энелик көзөмөл колдонмосу',
      cta: 'Азыр байкап көрүү',
      items: [
        { icon: '/Location.png', img: '/GpsBoy.png', title: 'GPS-трекер', text: 'Баланыңыз кайда экенин дайыма билиңиз, ал коопсуз аймактан чыгып кетсе эскертме алыңыз.' },
        { icon: '/Ear.png', img: '/AudioGirl.png', title: 'Угуу', text: 'Бала телефонду албаса да, анын айланасындагы үндөрдү чыныгы убакытта угуңуз.' },
        { icon: '/Limit.png', img: '/GamingBoy.png', title: 'Оюндарга чектөө', text: 'Колдонмолорду пайдалануу убактысын чектеңиз жана сайттарды бөгөттөңүз.' },
      ],
    },
    apps: {
      parentName: 'Kid Security', parentRole: 'Ата-эне үчүн колдонмо',
      kidName: 'Tigrow', kidRole: 'Бала үчүн колдонмо',
      result: 'Баланы комплекстүү коргоо!',
    },
    kids: {
      title: 'Балдарга «Tigrow» эмнеси менен жагат?',
      sub: 'Kid Security менен жуп иштеген балдар үчүн колдонмо',
      items: [
        { icon: '/Rocket.png', img: '/BoyOnRocket.png', title: 'Кыялдар чындыкка айланат', text: 'Бала кыялын колдонмого киргизет, сиз анын баасын виртуалдык монеталар менен аныктайсыз. Керектүү сумманы чогултканда кыял ишке ашат!' },
        { icon: '/Heart.png', img: '/GirlOnPhoneCard.png', title: 'Өсүүгө түрткү', text: 'Күн сайын бала окуу, үй жана спорт боюнча пайдалуу тапшырмаларды аткарып, виртуалдык монеталарды табат!' },
        { icon: '/Controller.png', img: '/BoyOnEarth.png', title: 'Монеталарды көңүл ачууга алмаштыруу', text: 'Тапкан монеталарын бала кыялга да, телефондогу оюндарга жана көңүл ачууга кошумча убакытка да алмаштыра алат!' },
      ],
    },
    flow: [{ title: 'Кызматты туташтырыңыз', text: 'Номериңизди киргизип, «Жазылуу» баскычын басыңыз' },{ title: 'Колдонмону жүктөңүз', text: 'Телефонуңузга Kid Security орнотуңуз' },{ title: 'ПИН-кодду киргизиңиз', text: 'Баланын телефонун ПИН-код менен байланыштырыңыз' }],
    formula: ['1 туташуу', '2 жүктөө', '1 сервис'],
    steps: {
      title: '3 жөнөкөй кадам',
      step: 'Кадам',
      s1: {
        title: 'Тарифти туташтырыңыз',
        text: 'Beeline’де Kid Security кызматына акысыз жазылуусу бар тарифтер бар.',
        cta: 'Тариф тандоо', or: 'Же', title2: 'Кызматты туташтырыңыз',
        text2: 'Эгер тарифиңизде акысыз жазылуу жок болсо, аны өзүнчө күнүнө 12 сомдон туташтырыңыз.', cta2: 'Кызматты туташтыруу',
      },
      s2: {
        title: 'Ата-энеге Kid Security колдонмосун жүктөңүз',
        text: 'Kid Security – ата-энелер үчүн колдонмо: баланы GPS аркылуу байкоого, экрандагы убакытты көзөмөлдөөгө жана үй-бүлө менен байланышта болууга жардам берет.',
        text2: 'Бул колдонмодо ПИН-код түзүп, аны баланын номерине жөнөтүңүз – ошондо ал сизге байланат.',
      },
      s3: {
        title: 'Балага Tigrow колдонмосун жүктөңүз',
        text: 'Tigrow Kid Security менен жуп иштейт. Колдонмо баланыздын жайгашкан ордун көрсөтөт жана ага пайдалуу тапшырмалар үчүн виртуалдык монеталарды таап алууга мүмкүнчүлүк берет.',
        text2: 'Ата-энеге байланыш үчүн Tigrow колдонмосуна ПИН-кодду киргизиңиз.',
      },
    },
    tariffs: {
      title: 'Kid Security жазылуусу бар тарифтер',
      perMonth: '/ 30 күн', gb: 'ГБ', unlimited: 'Чексиз интернет', family: 'Үй-бүлө', thisIs: 'Бул',
      wifi: 'Wi-Fi таратуу үчүн 10 ГБ',
      bonuses: (n) => `Тандоо боюнча ${n} акысыз бонус`,
      inBonus: 'Kid Security бонус пакетинде',
      sim: 'SIM-карта алуу',
      more: 'Кененирээк',
    },
    faq: {
      title: 'Көп берилүүчү суроолор',
      items: [
        { q: 'Kid Security деген эмне?', a: 'Kid Security – ата-энелик көзөмөл колдонмосу: коопсуз аймактар жөнүндө эскертмелери бар GPS-жайгашуу, угуу, колдонмолорго убакыт чектөө жана сайттарды бөгөттөө бир жерде.' },
        { q: 'Канча турат?', a: 'Кызмат күнүнө 12 сом турат жана Beeline балансынан алынат. Айрым Beeline тарифтерине ал акысыз кирет.' },
        { q: 'Ким туташтыра алат?', a: 'Beeline Кыргызстандын ар бир абоненти. Кызмат үчүн Beeline номери аркылуу төлөнөт, ошондуктан башка оператордун номери жаза албайт.' },
        { q: 'Экинчи колдонмо керекпи?', a: 'Ооба. Ата-эненин телефонуна Kid Security, баланын телефонуна Tigrow орнотуп, аларды ПИН-код менен байланыштырыңыз.' },
        { q: 'Кызматты кантип өчүрөм?', a: 'Жазылууну «Мой Beeline» колдонмосунда башкарыңыз же өчүрүңүз, же *611 маалымат номерине чалыңыз.' },
      ],
    },
    manage: { title: '«Мой Beeline» колдонмосунда кызматты оңой башкарыңыз' },
    sticky: 'Жазылуу',
    footer: { offices: 'Сатуу кеңселери', help: 'Маалымат кызматы', rights: 'Бардык укуктар корголгон' },
    result: {
      successTitle: 'Даяр! Кызмат туташты',
      successText: 'Өз телефонуңузга Kid Security, баланын телефонуна Tigrow жүктөп, аларды ПИН-код менен байланыштырыңыз.',
      failedTitle: 'Бир нерсе туура эмес болду',
      failedText: 'Кызматты туташтыруу мүмкүн болгон жок. Кийинчерээк кайра аракет кылыңыз.',
      back: 'Баракчага кайтуу',
    },
  },
};
